import { alpha } from '@mui/material'

// Shared look for panels floating over the Radar / Review map (clock, unit badge, tool bar,
// replay panel). Mostly transparent with only a light blur, so targets and the map stay
// visible underneath; a text shadow keeps the text readable on any map color.
export const OVERLAY_BG = 'rgba(8, 12, 16, 0.38)'
export const OVERLAY_BG_HOVER = 'rgba(8, 12, 16, 0.62)'   // panels you interact with get darker on hover

export const overlayTextShadow = '0 1px 2px rgba(0,0,0,0.9), 0 0 6px rgba(0,0,0,0.6)'

export const glassSx = (accent, { interactive = false } = {}) => ({
  backgroundColor: OVERLAY_BG,
  backdropFilter: 'blur(2px)',
  WebkitBackdropFilter: 'blur(2px)',
  border: `1px solid ${alpha(accent, 0.28)}`,
  boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
  textShadow: overlayTextShadow,
  transition: 'background-color .2s ease',
  ...(interactive && { '&:hover, &:focus-within': { backgroundColor: OVERLAY_BG_HOVER } }),
})
